/* import __COLOCATED_TEMPLATE__ from './selected-flair.hbs'; */
import SelectedNameComponent from "select-kit/components/selected-name";
export default SelectedNameComponent.extend({
  tagName: ""
});